import gql from 'graphql-tag';

export const ArchivePagesMutation = gql`
	mutation ArchivePagesMutation($input: [BulkArchivePagesInput]!) {
		archivePages(input: $input) {
			taskId
			status
		}
	}
`;
